import 'bootstrap'
import '@fortawesome/fontawesome-free/js/all'
import Rails from '@rails/ujs'
import { initReact } from '../src/lib/react'

initReact()
Rails.start()
